import { Empty, Spin } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import LXCenter from '../center';

const LXSimpleListContainer = styled.div`
  width: 960px;
  min-height: 840px;
`;

interface LXSimpleListProps<T> {
  datas: T[];
  itemBuilder: (data: T, idx: number) => ReactNode;
  isLoading?: boolean;
}

const LXSimpleList = <T,>(props: LXSimpleListProps<T>) => {
  const buildItems = () => {
    return props.datas.map(props.itemBuilder);
  };

  if (props.isLoading) {
    return (
      <LXSimpleListContainer>
        <LXCenter>
          <Spin size={'large'}></Spin>
        </LXCenter>
      </LXSimpleListContainer>
    );
  }
  if (props.datas.length === 0)
    return (
      <LXSimpleListContainer>
        <LXCenter>
          <Empty></Empty>
        </LXCenter>
      </LXSimpleListContainer>
    );
  return <LXSimpleListContainer>{buildItems()}</LXSimpleListContainer>;
};

export default LXSimpleList;
